import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = {role: ROLE.SUPER_ADMIN};

const path = "admin/appointment";


export const List = async (values) => {
  return await axiosInstance(options).post(`${path}/list`, values);
};

export const Details = async (values) => {
  return await axiosInstance(options).post(`${path}/details`, values);
};

export const AssociateList = async (values) => {
  return await axiosInstance(options).post(`${path}/available-associate` , values)
}

export const accociateUpdate = async (values) => {
  return await axiosInstance(options).patch(`${path}/assign-manually`,values)
}

